import React from "react";

const InitialsInput = React.forwardRef(
  ({ name, label, className, error, onChange, ...rest }, ref) => {
    return (
      <div className="mb-3" {...rest}>
        <input
          className={`form-control me-2${className ? ` ${className}` : ""}`}
          style={{ width: "100px", display: "inline-block" }}
          {...rest}
          name={name}
          id={name}
          ref={ref}
          onChange={onChange}
        />
        <label
          className={error ? "text-danger" : "text-safy-success"}
          htmlFor={name}
        >
          {label}
        </label>
        {error && <div className="alert alert-danger">{error}</div>}
      </div>
    );
  }
);

export default InitialsInput;
